<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
      <g transform="translate(-268.13 -242.147)">
        <path d="M276.183,255.627h7.893c1.088-0.004,1.969-0.885,1.973-1.973v-7.894c-0.004-1.088-0.885-1.969-1.973-1.973h-12.829
          c-1.086,0.004-1.964,0.887-1.963,1.973l-0.01,13.813l3.947-3.947h2.96L276.183,255.627z M272.403,253.654l-1.153,1.154v-9.048
          h12.827v7.893L272.403,253.654L272.403,253.654z"/>
        <path d="M290.973,250.693c0.001-1.086-0.877-1.969-1.963-1.973h-0.987v1.973h0.987v9.048l-1.154-1.154H276.18V257.6h-1.97v0.987
          c0.003,1.088,0.885,1.97,1.973,1.973h10.853l3.947,3.947L290.973,250.693z"/>
      </g>
      </svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'discussion'
}
</script>
